// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapsible-filter-panel-group[data-v-5a644f65]{display:flex;justify-content:flex-end;grid-gap:20px;gap:20px;position:relative;flex-grow:1}[data-v-5a644f65] .content-container.content-container{position:static}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
